import { render, staticRenderFns } from "./HomeFa.vue?vue&type=template&id=5ddc1a90&"
import script from "./HomeFa.vue?vue&type=script&lang=js&"
export * from "./HomeFa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports